class DeliveryTimeV2 extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day");
        this.excludedDays = this.getAttribute("data-exclude-day").replace(/ /g, '').split(",");
        this.numbDateStart = this.getAttribute("data-estimate-start");
        this.numbDateEnd = this.getAttribute("data-estimate-end");
        this.targetTime = this.getAttribute("data-time");
        this.cutoffHours = parseInt(this.getAttribute("data-cutoff-hours")) || 6;
        this.orderByText = this.getAttribute("data-order-by-text") || "Order in";
        this.getItByText = this.getAttribute("data-get-it-by-text") || "Get it by";
        
        this.hr = this.querySelector('.productView-dlvr-v2__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr-v2__remaining-mins');
        this.orderByWrapper = this.querySelector('.productView-dlvr-v2__order-by');
        this.deliveryDateEl = this.querySelector('.productView-dlvr-v2__delivery-date');
        
        this.iso_code = document.documentElement.lang;
        this.checkExclude = this.checkAllExcludeDays(this.excludedDays);

        if (this.checkExclude) return;

        this.productDeliveryTime();
        this.updateCountdown();

        setInterval(() => {
            this.updateCountdown();
        }, 1000);

        this.style.display = "flex";
    }

    // Check if current day is excluded
    checkAllExcludeDays(excludedDays) {
        const now = new Date();
        const deliveryDateTime = new Date(now);

        for (let day of excludedDays) {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) return true;
        }

        return false;
    }

    productDeliveryTime() {
        const $orderDlvr = this;
        if (!$orderDlvr) return;

        let startDay = this.excludeDays(this.excludedDays, this.numbDateStart);
        const formattedStartDate = this.formatDate(startDay, this.formatString);

        if (this.deliveryDateEl) {
            this.deliveryDateEl.textContent = formattedStartDate;
        }
    }

    updateCountdown() {
        const countdown = this.countdownToTime(this.targetTime);
        
        if (this.hr) this.hr.textContent = countdown.hours;
        if (this.mins) this.mins.textContent = countdown.minutes;

        // Hide "Order in" text and separator if more than cutoff hours remaining
        const separatorEl = this.querySelector('.productView-dlvr-v2__separator');
        
        if (this.orderByWrapper) {
            const totalHours = countdown.hours + (countdown.minutes / 60);
            if (totalHours > this.cutoffHours) {
                this.orderByWrapper.style.display = 'none';
                if (separatorEl) separatorEl.style.display = 'none';
            } else {
                this.orderByWrapper.style.display = '';
                if (separatorEl) separatorEl.style.display = '';
            }
        }
    }

    // Format dayOfWeek/dayOfMonth/month/year according to format string
    formatDate(dateString, formatString) {
        const date = new Date(dateString);
        const locale = this.iso_code || 'en-US';
        const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long' }),
            dayOfMonth = date.toLocaleDateString(locale, { day: '2-digit' }),
            month = date.toLocaleDateString(locale, { month: 'short' }),
            monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'),
            year = date.toLocaleDateString(locale, { year: 'numeric' });

        const formattedDate = formatString
            .replace('d', dayOfWeek)
            .replace('DD', dayOfMonth)
            .replace('MMM', month)
            .replace('MM', monthNumber)
            .replace('YYYY', year);

        return formattedDate;
    }

    // Exclude specified days from delivery calculation
    excludeDays(excludedDays, dataRange) {
        const now = new Date(),
            deliveryDateTime = new Date(now);

        // Add delivery days to current time
        deliveryDateTime.setDate(deliveryDateTime.getDate() + parseInt(dataRange));
        excludedDays.forEach(day => {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) {
                // Move to next day if it matches excluded day
                deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
            }
        });

        return deliveryDateTime.toLocaleDateString('en-US');
    }

    // Countdown to target time
    countdownToTime(targetTime) {
        const currentTime = new Date(),
            targetTimeString = `${currentTime.toDateString()} ${targetTime}`,
            targetDateTime = new Date(targetTimeString);

        // If target time has passed today, move to next day
        if (targetDateTime < currentTime) targetDateTime.setDate(targetDateTime.getDate() + 1);

        // Time remaining between current time and target time
        const remainingTime = targetDateTime - currentTime;

        const hours = Math.floor(remainingTime / (1000 * 60 * 60)),
            minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

        return { hours, minutes };
    }
}

customElements.define('delivery-time-v2', DeliveryTimeV2);
